import { AttendanceCycle } from 'generated/resources/graphql'
import moment from 'moment'

import { formatBackendDateToMonthDayYearLong } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Params {
  openPeriod: boolean
  lastCycle: Pick<AttendanceCycle, 'startDate' | 'endDate'> | undefined
}

const getTagDescription = ({ openPeriod, lastCycle }: Params) => {
  if (openPeriod) {
    const todayIsLastCycleStart = moment().format('YYYY-MM-DD') === lastCycle?.startDate

    if (todayIsLastCycleStart) {
      return i18n.t('clock_in.bank_of_hours.button.open_cycle_start_today_description')
    } else {
      return i18n.t('clock_in.bank_of_hours.button.cycle_description_today', {
        cycleStart: formatBackendDateToMonthDayYearLong(lastCycle?.startDate ?? ''),
      })
    }
  } else {
    return i18n.t('clock_in.bank_of_hours.button.cycle_description', {
      cycleStart: formatBackendDateToMonthDayYearLong(lastCycle?.startDate ?? ''),
      cycleEnd: formatBackendDateToMonthDayYearLong(lastCycle?.endDate ?? ''),
    })
  }
}

export default getTagDescription
